export default "__VITE_ASSET__73216d9c__"